import { FlaskConical } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { money } from "@/lib/api";

export function ReconOptions({ value, onChange, recommendedMl, fee, quantity, prefix }) {
  const opt = (key, label, sub) => (
    <button
      type="button"
      data-testid={`${prefix}-bac-${key}-option`}
      onClick={() => onChange({ bac_option: key })}
      className={`flex-1 rounded-md border px-3 py-2 text-left transition-colors ${
        value.bac_option === key ? "border-emerald-500 bg-emerald-500/10" : "border-border hover:bg-secondary"
      }`}
    >
      <div className="text-sm font-medium">{label}</div>
      <div className="font-mono-data text-xs text-muted-foreground">{sub}</div>
    </button>
  );

  return (
    <div className="rounded-md border border-border bg-background/40 p-4">
      <label className="flex cursor-pointer items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-sm">
          <FlaskConical className="h-4 w-4 text-emerald-400" />
          Reconstitute it for me
          <span className="font-mono-data text-xs text-muted-foreground">+{money(fee)}/vial</span>
        </span>
        <Switch
          data-testid={`${prefix}-reconstitute-switch`}
          checked={value.reconstitute}
          onCheckedChange={(v) => onChange({ reconstitute: v })}
        />
      </label>
      {value.reconstitute && (
        <div className="mt-4 space-y-3 rise">
          <div className="flex flex-col gap-2 sm:flex-row">
            {opt("recommended", "Use recommended", `${recommendedMl} mL BAC water`)}
            {opt("custom", "Custom amount", "0.5 – 10 mL")}
          </div>
          {value.bac_option === "custom" && (
            <div className="flex items-center gap-2">
              <Input
                data-testid={`${prefix}-bac-custom-ml-input`}
                type="number"
                step="0.1"
                min="0.5"
                max="10"
                placeholder="e.g. 2.5"
                value={value.custom_bac_ml}
                onChange={(e) => onChange({ custom_bac_ml: e.target.value })}
                className="w-32 font-mono-data"
              />
              <span className="text-sm text-muted-foreground">mL per vial</span>
            </div>
          )}
          <p className="text-xs text-muted-foreground">
            Fee covers BAC water and sterile syringes · {quantity} vial{quantity > 1 ? "s" : ""} ={" "}
            <span className="font-mono-data text-emerald-400">{money(fee * quantity)}</span>
          </p>
        </div>
      )}
    </div>
  );
}
